import { AnyAction, Dispatch } from 'redux';
import { initializeStore, SeamlessConnection, SeamlessCoreStore } from '@seamless/store';
import { initializeStoreConnection, usePersistentStore } from '../store.util';
import { IDealerContext } from '../../models/dealer.model';

export type DealerContextState = {
  DealerContext: IDealerContext | null;
};

export type DealerContextDispatchers = {
  setDealerContext: (payload: IDealerContext | null) => void;
};

export const connectionName = 'EMH_DEALER_CONTEXT';

export const { initialState, updateState } = usePersistentStore<DealerContextState>(connectionName, {
  DealerContext: null,
});

export class DealerContextConnection extends SeamlessConnection<DealerContextDispatchers, DealerContextState> {
  private readonly SET_DEALER_CONTEXT = `${connectionName}.SET_DEALER_CONTEXT`;

  constructor() {
    super(connectionName);
  }

  get initialState(): DealerContextState {
    return initialState;
  }

  getReducer() {
    return (state: DealerContextState, action: AnyAction): DealerContextState => {
      switch (action.type) {
        case this.getActionType(this.SET_DEALER_CONTEXT):
          return updateState(state, { DealerContext: action.payload });
        default:
          return state;
      }
    };
  }

  getPublicDispatchers() {
    return {
      setDealerContext: (payload: IDealerContext | null) => (dispatch: Dispatch) => {
        dispatch(this.getAction(this.SET_DEALER_CONTEXT, payload));
      },
    };
  }
}

const store = initializeStore();

export const getDealerContextState = async (): Promise<DealerContextState> =>
  new Promise((resolve) => {
    store.once(connectionName, (state: DealerContextState) => resolve(state));
  });

export let dealerContextStore: SeamlessCoreStore;
export let dealerContextDispatchers: DealerContextDispatchers;

export const initializeDealerContextStore = async () => {
  dealerContextStore = (await initializeStoreConnection<DealerContextState, DealerContextDispatchers>(
    DealerContextConnection,
  )) as SeamlessCoreStore;
  dealerContextDispatchers = {
    ...(await dealerContextStore.getConnectionDispatchers<DealerContextDispatchers>(connectionName)),
    ...dealerContextDispatchers,
  };
};
